export class DailySafetyLearnedEmployee {
    id = ''
    meetingId = ''
    sortOrder = 0
    employeeHrRef: number | null = null
    learnedAbout = ''
}

export class DailySafetyMeetingTask {
    id = ''
    meetingId = ''
    sortOrder = 0
    employeeHrRef: number | null = null
    hazards = ''
    controlDescription = ''
    affectedParties = ''
}

export class DailySafetyEmployeeSignature {
    id = ''
    meetingId = ''
    sortOrder = 0
    signature = ''
    signedOn: Date | string | null = null
}

export class DailySafetyCoordinationMeeting {
    id!: string
    indexId!: number
    job?: string | null
    meetingDateTime?: Date | string | null
    jobPhase?: string | null
    yesterdayInjuryWho?: string | null
    reportedToSafety = false
    segue?: string | null
    learnedAboutForeman?: string | null
    acknowledgedEmployeeHrRef?: number | null
    acknowledgedWhy?: string | null
    safetyTopicThaReview?: string | null
    issues?: string | null
    issuesResolved?: string | null
    foremanSignature?: string | null
    foremanSignedOn?: Date | string | null
    createdOn?: Date | string | null
    createdByUserId?: string | null
    archived!: boolean

    learnedEmployees: DailySafetyLearnedEmployee[] = []
    tasks: DailySafetyMeetingTask[] = []
    employeeSignatures: DailySafetyEmployeeSignature[] = []

    jobDisplay?: string | null

    static createNew(): DailySafetyCoordinationMeeting {
        const item = new DailySafetyCoordinationMeeting()
        item.id = crypto.randomUUID()
        return item
    }

    protected $setProperties(source: any): void {
        source.learnedEmployees = source.learnedEmployees ?? []
        source.tasks = source.tasks ?? []
        source.employeeSignatures = source.employeeSignatures ?? []
        source.jobDisplay = source.jobDisplay ?? source.job ?? ''
    }
}
